import {Button, Modal} from 'letrus-ui';
import styles from './TransferNoticeModal.module.scss';

export interface TransferNoticeModalProps {
  previousSchoolGroup: string;
  onClose(): void;
}

function TransferNoticeModal({
  previousSchoolGroup,
  onClose,
}: TransferNoticeModalProps): JSX.Element {
  return (
    <Modal id="transferNoticeModal" className={styles.modal}>
      <div className={styles.content} data-testid="transferNoticeModal">
        <h2>Você foi transferido de turma</h2>

        <p>
          Identificamos que você foi transferido para uma nova turma. Por causa
          disso, o histórico de atividades da turma anterior (
          {previousSchoolGroup}) ficará temporariamente indisponível.
        </p>

        <p>
          Você continuará tendo acesso às atividades em andamento e também às
          novas atividades da sua nova turma. Se tiver dúvidas, procure seu
          professor.
        </p>

        <div className={styles.actions}>
          <Button variant="primary" type="button" onClick={onClose}>
            Entendi
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export default TransferNoticeModal;
